import { computed as l, createElementBlock as a, openBlock as s, createBlock as c, createCommentVNode as d, unref as r, renderSlot as u, createElementVNode as o } from "vue";
import { _ as p } from "./DIcon.js";
const m = { "data-spark": "dloader" }, C = {
  key: 1,
  class: "ghost-loader animate-pulse space-y-4"
}, x = {
  __name: "DLoader",
  props: {
    active: {
      type: Boolean,
      default: !0,
      description: "If true, the loader is active and animating."
    },
    size: {
      type: String,
      default: "base",
      validator: (e) => [
        "xs",
        "sm",
        "base",
        "md",
        "lg",
        "xl"
      ].includes(e),
      description: "Size of the loader."
    },
    type: {
      type: String,
      default: "ring",
      validator: (e) => [
        "ring",
        "ghost"
      ].includes(e),
      description: "Type of loader animation."
    }
  },
  setup(e) {
    const n = e, t = l(() => {
      switch (n.size) {
        case "xs":
          return "3";
        case "sm":
          return "4";
        case "base":
          return "5";
        case "md":
          return "6";
        case "lg":
          return "8";
        case "xl":
          return "10";
        default:
          return "5";
      }
    });
    return (i, g) => (s(), a("div", m, [
      e.type === "ring" ? (s(), c(p, {
        key: 0,
        icon: "load",
        spin: e.active,
        size: `w-${r(t)} h-${r(t)}`,
        type: "small"
      }, null, 8, ["spin", "size"])) : e.type === "ghost" ? (s(), a("div", C, [
        u(i.$slots, "default")
      ])) : d("", !0)
    ]));
  }
}, f = {
  "aria-hidden": "true",
  class: "inline max-w-[80px] max-h-[80px] animate-spin text-accent-empty fill-focus",
  viewBox: "0 0 49 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, y = {
  __name: "DLoading",
  setup(e) {
    return (n, t) => (s(), a("svg", f, t[0] || (t[0] = [
      o("path", {
        d: "M48.5 24.5C48.5 37.7548 37.7548 48.5 24.5 48.5C11.2452 48.5 0.5 37.7548 0.5 24.5C0.5 11.2452 11.2452 0.5 24.5 0.5C37.7548 0.5 48.5 11.2452 48.5 24.5ZM7.98361 24.5C7.98361 33.6218 15.3782 41.0164 24.5 41.0164C33.6218 41.0164 41.0164 33.6218 41.0164 24.5C41.0164 15.3782 33.6218 7.98361 24.5 7.98361C15.3782 7.98361 7.98361 15.3782 7.98361 24.5Z",
        fill: "currentColor"
      }, null, -1),
      o("path", {
        d: "M44.7582 24.5C46.8247 24.5 48.5298 22.8148 48.2089 20.7733C47.9151 18.9041 47.4006 17.0718 46.6731 15.3156C45.467 12.4038 43.6992 9.75804 41.4706 7.52944C39.242 5.30083 36.5962 3.533 33.6844 2.32689C31.9282 1.59944 30.0959 1.08492 28.2267 0.791103C26.1852 0.470211 24.5 2.17526 24.5 4.2418C24.5 6.30834 26.1962 7.94147 28.2099 8.40566C29.0997 8.61075 29.973 8.88977 30.8205 9.24084C32.8244 10.0709 34.6452 11.2875 36.1789 12.8211C37.7125 14.3548 38.9291 16.1756 39.7592 18.1794C40.1102 19.027 40.3892 19.9003 40.5943 20.7901C41.0585 22.8038 42.6917 24.5 44.7582 24.5Z",
        fill: "currentFill"
      }, null, -1)
    ])));
  }
};
export {
  x as _,
  y as a
};
